import React from "react";

function ServerUnavailable() {
  return (
    <span>Server unavailale. Unable to complete trade at this time. </span>
  );
}

export default ServerUnavailable;
